// src/components/UploadIcon.js
import React, { useState } from 'react';
import { Button, Input, Form, Message } from 'semantic-ui-react';
import { storage, db } from '../firebase';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { useAuth } from '../contexts/AuthContext';

export default function UploadIcon() {
  const [file, setFile] = useState(null);
  const [prompt, setPrompt] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { currentUser } = useAuth();

  const handleFileChange = (e) => {
    const selected = e.target.files[0];
    if (selected && selected.type.startsWith('image/')) {
      setFile(selected);
      setError('');
    } else {
      setFile(null);
      setError('Please select a valid image file');
    }
  };

  const handlePromptChange = (e) => {
    setPrompt(e.target.value);
  };

  const handleUpload = async () => {
    if (!file) return;

    setLoading(true);

    const storageRef = ref(storage, `icons/${currentUser.uid}/${file.name}`);

    try {
      const snapshot = await uploadBytes(storageRef, file);
      const downloadURL = await getDownloadURL(snapshot.ref);

      await addDoc(collection(db, 'submissions'), {
        uid: currentUser.uid,
        iconURL: downloadURL,
        createdAt: serverTimestamp(),
        status: 'pending', // Add status field
        prompt: prompt,
      });

      setFile(null);
      setError('');
      setPrompt('');
    } catch (err) {
      console.error(err);
      setError('Failed to upload icon');
    }

    setLoading(false);
  };

  return (
    <Form>
      <Form.Field required>
        <label>Upload Your Icon (JPEG, PNG, WebP, GIF, AVIF, TIFF or SVG)</label>
        <Input type="file" accept="image/*" onChange={handleFileChange} />
      </Form.Field>
      <Form.Field>
        <label>What animation do you want? (optional)</label>
        <Input type="input" value={prompt} onChange={handlePromptChange} />
      </Form.Field>
      {error && <Message negative>{error}</Message>}
      <Button primary onClick={handleUpload} loading={loading} disabled={loading || !file}>
        Submit Icon
      </Button>
    </Form>
  );
}
